export default __webpack_public_path__ + "static/media/Bandit's Boots of the Grasslands.f50e0da7.jpg";